import { MouseEvent } from 'react';

import { ModuleConstructor } from 'common/apps/core/types';

import {
  GetSurveyDataType,
  SurveyDataQuestionType,
} from './services/getSurveyDataService/shemes/getSurveyDataScheme';

export enum SurveyButtonType {
  Next = 'buttonNext',
  Prev = 'buttonPrev',
}

export enum SurveyDataType {
  Rate = 'estimateFive',
  Text = 'freeAnswer',
}

export type SurveyAnswer = {
  answer: string;
  id: string;
};

export type SurveyDataProps = {
  questions: ({ answer?: string } & SurveyDataQuestionType)[];
} & Exclude<GetSurveyDataType, 'questions'>;

export namespace Survey {
  export type ModuleState = {
    isLoading: boolean;
    isSurveySubmitted: boolean;
    surveyData: Nullable<SurveyDataProps>;
    activeStep: number;
  };

  export type ModuleApi = {
    handleShowModal: (payload: MouseEvent<HTMLButtonElement>) => void;
    handleAnswer: (payload: { id: string; answer: string }) => void;
    handleChangeStep: (payload: MouseEvent<HTMLButtonElement>) => void;
  };

  export type Module = ModuleConstructor<
    'survey',
    ModuleState,
    ModuleApi,
    never,
    []
  >;
}
